import React from 'react';

class LoadingSpinner extends React.Component {
    private loadingStyle: any = {
        position: 'absolute',
        height: '100%',
        width: '100%',
        fontSize: '1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    };

    private rollerStyle: any = {
        display: 'inline-block',
        position: 'relative',
        width: '8em',
        height: '8em'
    };

    private divStyle: any = {
        animation: 'lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
        transformOrigin: '4em 4em'
    };

    private baseStyle: any = {
        position: 'absolute',
        display: 'block',
        width: '0.7em',
        height: '0.7em',
        borderRadius: '50%',
        background: 'black',
        margin: '-0.4em 0 0 - 0.4em',
    };

    private baseDelay: number = 0.036;


    render() {
        this.baseStyle.background = 'black';

        return (
            <div className="loading" style={this.loadingStyle}>
                <div className="lds-roller" style={this.rollerStyle}>
                    <div style={{ ...this.divStyle, animationDelay: `${this.baseDelay * 8}s` }} ><div style={{ ...this.baseStyle, top: '6.3em', left: '6.3em' }} /></div>
                    <div style={{ ...this.divStyle, animationDelay: `${this.baseDelay * 7}s` }} ><div style={{ ...this.baseStyle, top: '6.8em', left: '5.6em' }} /></div>
                    <div style={{ ...this.divStyle, animationDelay: `${this.baseDelay * 6}s` }} ><div style={{ ...this.baseStyle, top: '7.1em', left: '4.8em' }} /></div>
                    <div style={{ ...this.divStyle, animationDelay: `${this.baseDelay * 5}s` }} ><div style={{ ...this.baseStyle, top: '7.2em', left: '4.0em' }} /></div >
                    <div style={{ ...this.divStyle, animationDelay: `${this.baseDelay * 4}s` }} ><div style={{ ...this.baseStyle, top: '7.1em', left: '3.2em' }} /></div >
                    <div style={{ ...this.divStyle, animationDelay: `${this.baseDelay * 3}s` }} ><div style={{ ...this.baseStyle, top: '6.8em', left: '2.4em' }} /></div >
                    <div style={{ ...this.divStyle, animationDelay: `${this.baseDelay * 2}s` }} ><div style={{ ...this.baseStyle, top: '6.3em', left: '1.7em' }} /></div >
                    <div style={{ ...this.divStyle, animationDelay: `${this.baseDelay * 1}s` }} ><div style={{ ...this.baseStyle, top: '5.6em', left: '1.2em' }} /></div >
                </div>
            </div>
        );
    }
}
  
export default LoadingSpinner;
  